export const PROFILE_GET_REQUEST = 'PROFILE_GET_REQUEST'
export const PROFILE_GET_SUCCESS = 'PROFILE_GET_SUCCESS'
export const PROFILE_GET_ERROR = 'PROFILE_GET_ERROR'